export const prechargeReports = {
	title: "Informes de Precarga",
	filterByDate: "Filtrar por fecha",
	cards: {
		retrievedRecharge: "Recargas Rescatadas",
		consumedValue: "Recargas Utilizadas",
		avgRechargedValue: "Ticket Promedio de las recargas dadas",
		avgRetrievedValueByDay: "Promedio de rescate por día",
		gender: {
			label: "División de Género",
			male: {
				title: "{{percent}}% de Hombres",
				acronym: "H",
			},
			female: {
				title: "{{percent}}% de Mujeres",
				acronym: "M",
			},
			other: {
				title: "{{percent}}% de Otros",
				acronym: "O",
			},
		},
	},
	table: {
		exportToExcel: {
			title: "{{placeName}}_{{date}}",
			filename: "{{placeName}}_{{date}}",
		},
		columns: {
			date: "Fecha",
			maleQuantity: "Total de Recargas para Hombres",
			femaleQuantity: "Total de Recargas para Mujeres",
			otherQuantity: "Total de Recargas para Otros",
			topUpQuantity: "Cant Total de Recargas",
			redeemedQuantity: "Cant Total de Rescates",
			accumulatedValue: "Valor Acumulado",
			bonusValue: "Valor Bono",
			redeemedValue: "Valor Rescatado",
			usedValue: "Valor Utilizado",
		},
	},
};
